// extracted by mini-css-extract-plugin
module.exports = {"container":"what_container__3ks5Z","header":"what_header__1Pzrr","iframe":"what_iframe__2cBhp","iframe2":"what_iframe2__21Q8G","subContainer2":"what_subContainer2__1h5gs"};